import { call, put, takeEvery } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import {
  formsSuccess,
  formsFailure,
  formSuccess,
  formFailure,
  createFormSuccess,
  createFormFailure,
  updateFormSuccess,
  updateFormFailure,
  editFormSuccess,
  editFormFailure,
  deleteFormSuccess,
  deleteFormFailure,
  readFormsSuccess,
  readFormsFailure,
} from './actions';
import {
  FORMS_REQUEST,
  FORM_REQUEST,
  CREATE_FORM_REQUEST,
  UPDATE_FORM_REQUEST,
  EDIT_FORM_REQUEST,
  DELETE_FORM_REQUEST,
  PRINTED_FORMS_REQUEST,
  LOAD_DEAL_FORMS_REQUEST,
} from './actionTypes';
import FormService from '../../services/FormService';
import DealService from '../../services/DealService';
import { dealFailure, dealSuccess } from '../deals/actions';
import { getDealer } from '../deals/sagas';

export function* getFormsTask(action) {
  const params = action.payload;
  try {
    const list = yield call(FormService.getForms, params);
    yield put(formsSuccess(list));
  } catch (error) {
    yield put(formsFailure(error));
  }
}

export function* readFormsTask(action) {
  const params = action.payload;
  try {
    const list = yield call(FormService.readForms, params);
    yield put(readFormsSuccess(list));
  } catch (error) {
    yield put(readFormsFailure(error));
  }
}

export function* getFormTask(action) {
  try {
    const formId = action.payload;
    const form = yield call(FormService.getForm, formId);
    yield put(formSuccess(form));
  } catch (error) {
    yield put(formFailure(error));
  }
}

export function* createFormTask(action) {
  try {
    const params = action.payload;
    const form = yield call(FormService.createForm, params);
    yield put(createFormSuccess(form));
    yield put(replace(`/${params.dealer_id}/forms`));
  } catch (error) {
    yield put(createFormFailure(error));
  }
}

export function* updateFormTask(action) {
  try {
    const params = action.payload;
    const form = yield call(FormService.updateForm, params);
    yield put(updateFormSuccess(form));
    yield put(replace(`/${params.dealer_id}/forms`));
  } catch (error) {
    yield put(updateFormFailure(error));
  }
}

export function* editFormTask(action) {
  try {
    const { formId, changes } = action.payload;
    const form = yield call(FormService.editForm, formId, changes);
    yield put(editFormSuccess(form));
  } catch (error) {
    yield put(editFormFailure(error));
  }
}

export function* deleteFormTask(action) {
  try {
    const formId = action.payload;
    yield call(FormService.deleteForm, formId);
    yield put(deleteFormSuccess(formId));
  } catch (error) {
    yield put(deleteFormFailure(error));
  }
}

export function* loadDealFormsTask(action) {
  try {
    const dealId = action.payload;
    const deal = yield call(DealService.getDeal, dealId);
    yield put(dealSuccess(deal));
    yield call(getDealer, deal.dealer_id);
    const dealerForms = yield call(FormService.getForms, deal.dealer_id);
    yield put(formsSuccess(dealerForms));
    const dealForms = yield call(FormService.readForms, dealId);
    yield put(readFormsSuccess(dealForms));
  } catch (error) {
    yield put(dealFailure(error));
  }
}

export function* formsSaga() {
  yield takeEvery(FORMS_REQUEST, getFormsTask);
  yield takeEvery(PRINTED_FORMS_REQUEST, readFormsTask);
  yield takeEvery(FORM_REQUEST, getFormTask);
  yield takeEvery(CREATE_FORM_REQUEST, createFormTask);
  yield takeEvery(UPDATE_FORM_REQUEST, updateFormTask);
  yield takeEvery(EDIT_FORM_REQUEST, editFormTask);
  yield takeEvery(DELETE_FORM_REQUEST, deleteFormTask);
  yield takeEvery(LOAD_DEAL_FORMS_REQUEST, loadDealFormsTask);
}
